<template>
  <v-container :class="this.$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-5'" class="m-0 p-0 rounded" fluid>
    <SelectUser v-if="showUserSelect" @userSelected="usersSelected" />
    <AbsenceOverview
      v-if="showAbsenceOverview"
      :date="date"
      :usersId="users"
      @selectUser="
        showAbsenceOverview = false;
        showUserSelect = true;
        users = [];
      "
    />
  </v-container>
</template>
<script>
export default {
  name: "UserAbsencesAdministartion",
  route: "AbsenceOverview",
  components: {
    SelectUser: () => import("./SelectUser"),
    AbsenceOverview: () => import("./AbsencesOverview")
  },

  data: (vm) => ({
    showAbsenceOverview: false,
    showUserSelect: true,
    users: [],
    date: null
  }),
  methods: {
    usersSelected(users, date) {
      for (let user of users) {
        this.users.push(user.SAPEmpID);
      }
      this.date = date;
      this.showAbsenceOverview = true;
      this.showUserSelect = false;
    }
  }
};
</script>
